// Modal.jsx
import AvatarEditor from 'react-avatar-editor';
import Dropzone from 'react-dropzone';
import React, { useEffect, useState, useRef, forwardRef } from 'react';
import '../assets/styles/card.css';
import uploadButton from '../assets/images/upload-button.png';
import {
    readFilesAndExtractURI,
    changeFileToJPG,
} from '../utils/ImageConvertResizer';

const PhotoUpload = (props) => {
    const setImage = props.setImage;

    async function onDrop(dropped) {
        let file = dropped[0];

        let jpgFile = await changeFileToJPG(file);
        let resizedImage = await readFilesAndExtractURI(jpgFile);

        setImage(resizedImage);
    }

    return (
        <Dropzone
            accept={{
                'image/*': ['.jpeg', '.png', '.heic'],
            }}
            onDrop={(dropped) => onDrop(dropped)}
            maxFiles={1}
            multiple={false}
        >
            {({ getRootProps, getInputProps }) => (
                <div id='center-dropzone' {...getRootProps()}>
                    <input {...getInputProps()} />
                    <div id='dropzone-container' className=''>
                        <img className='pixel-button' src={uploadButton} />
                    </div>
                </div>
            )}
        </Dropzone>
    );
};

export default PhotoUpload;
